import apiClient from '../apiClient';

/** Tenant: submit an upgrade request */
export const submitUpgradeRequest = async (requestedPlan, notes = '') => {
    const response = await apiClient.post('/tenant/subscription/upgrade-request', {
        requestedPlan,
        notes: notes || null,
    });
    return response.data;
};

/** Tenant: list own upgrade request history */
export const getMyUpgradeRequests = async () => {
    const response = await apiClient.get('/tenant/subscription/upgrade-requests');
    return response.data;
};

/** Admin: list all requests, optionally filtered by status */
export const getAllUpgradeRequests = async (status = null) => {
    const params = status ? { status } : {};
    const response = await apiClient.get('/admin/subscription/upgrade-requests', { params });
    return response.data;
};

/** Admin: count pending requests (for badge) */
export const countPendingUpgradeRequests = async () => {
    const response = await apiClient.get('/admin/subscription/upgrade-requests/count/pending');
    return response.data.count ?? 0;
};

/** Admin: approve a request */
export const approveUpgradeRequest = async (publicId, adminNotes = '') => {
    const response = await apiClient.post(`/admin/subscription/upgrade-requests/${publicId}/approve`, {
        adminNotes: adminNotes || null,
    });
    return response.data;
};

/** Admin: reject a request */
export const rejectUpgradeRequest = async (publicId, adminNotes = '') => {
    const response = await apiClient.post(`/admin/subscription/upgrade-requests/${publicId}/reject`, {
        adminNotes: adminNotes || null,
    });
    return response.data;
};
